module.exports = __webpack_public_path__ + "assets/img/not_data_tips-393b12cc.png";